"use client";

import React from "react";
import { MapPin, Phone, Mail, Facebook, Linkedin, Instagram, Twitter, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-primary-foreground/10 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <nav className="flex flex-col gap-3">
        <Link to="/MissionVisionPage" className="text-primary-foreground/80 hover:text-secondary transition-colors text-sm">
          Mission & Vision
        </Link>
        <Link to="/ImpactPage" className="text-primary-foreground/80 hover:text-secondary transition-colors text-sm">
          Our Impact
        </Link>
        <Link to="/PartnersPage" className="text-primary-foreground/80 hover:text-secondary transition-colors text-sm">
          Partners
        </Link>
        <Link to="/GetInvolvedPage" className="text-primary-foreground/80 hover:text-secondary transition-colors text-sm">
          Get Involved
        </Link>
      </nav>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-primary-foreground/80 hover:text-secondary transition-colors text-sm">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark bg-primary text-primary-foreground pt-16 pb-8 border-t border-primary-foreground/10">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/cohcc_foundation_logo_white.png" alt="COHCC Foundation Logo" className="h-16 w-auto object-contain" />
            </Link>
            <p className="text-primary-foreground/80 text-sm leading-relaxed max-w-xs">
              Expanding economic opportunity for Hispanic entrepreneurs, leaders, youth, and families through strategic programs and community partnerships.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h4 className="text-lg font-serif font-bold text-secondary">Quick Links</h4>
            <MenuProvider menu_id="40" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h4 className="text-lg font-serif font-bold text-secondary">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 text-secondary shrink-0 mt-0.5" />
                <span className="text-primary-foreground/80 text-sm">
                  1234 Hispanic Community Ave,<br />
                  Denver, CO 80202
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 text-secondary shrink-0" />
                <Link to="tel:3035557890" className="text-primary-foreground/80 hover:text-secondary transition-colors text-sm">
                  (303) 555-7890
                </Link>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 text-secondary shrink-0" />
                <Link to="mailto:info@cohccfoundation.org" className="text-primary-foreground/80 hover:text-secondary transition-colors text-sm">
                  info@cohccfoundation.org
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h4 className="text-lg font-serif font-bold text-secondary">Stay Connected</h4>
            <div className="flex gap-4">
              <Link to="https://facebook.com" newTab className="bg-primary-foreground/10 p-2 rounded-full hover:bg-secondary hover:text-primary transition-all duration-300 group flex items-center justify-center" aria-label="Facebook">
                <Facebook className="size-5 text-primary-foreground group-hover:text-primary" />
              </Link>
              <Link to="https://twitter.com" newTab className="bg-primary-foreground/10 p-2 rounded-full hover:bg-secondary hover:text-primary transition-all duration-300 group flex items-center justify-center" aria-label="Twitter">
                <Twitter className="size-5 text-primary-foreground group-hover:text-primary" />
              </Link>
              <Link to="https://linkedin.com" newTab className="bg-primary-foreground/10 p-2 rounded-full hover:bg-secondary hover:text-primary transition-all duration-300 group flex items-center justify-center" aria-label="LinkedIn">
                <Linkedin className="size-5 text-primary-foreground group-hover:text-primary" />
              </Link>
              <Link to="https://instagram.com" newTab className="bg-primary-foreground/10 p-2 rounded-full hover:bg-secondary hover:text-primary transition-all duration-300 group flex items-center justify-center" aria-label="Instagram">
                <Instagram className="size-5 text-primary-foreground group-hover:text-primary" />
              </Link>
            </div>
            
            <div className="pt-2">
              <Button className="w-full bg-secondary text-secondary-foreground hover:bg-secondary/90 font-bold shadow-lg hover:shadow-xl transition-all cursor-pointer">
                <Heart className="mr-2 size-4 fill-current" />
                Recurring Donation
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="border-t border-primary-foreground/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-primary-foreground/60">
          <p className="text-center md:text-left">
            &copy; {currentYear} COHCC Foundation | All Rights Reserved
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="#" className="hover:text-secondary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-secondary transition-colors">Terms of Service</Link>
            <span className="hidden md:inline text-primary-foreground/20">|</span>
            <span className="italic">Todos los derechos reservados</span>
          </div>
        </div>
      </div>
    </footer>;
}